module.exports = __webpack_public_path__ + "static/media/defaultAvatar.30d9bf23.png";